<template>
	<div>
		<div
			v-if="sortedPoints && !loading"
			v-for="point in sortedPoints"
			class="point"
			:class="{ 'active': point.id === selectedPointId }"
			:id="`point-${point.id}`"
			@click="$emit('onClick', point)"
			:key="point.id"
		>
			<b>{{ point.name || "Fermo Point" }}</b>
			<br>
			{{ point.address.street }}
			<br>
			{{ point.address.zip_code }}, {{ point.address.city }}
			<br>

			<point-schedule
				v-if="point['openingHours']"
				:schedule="point['openingHours'].schedule"
			/>
		</div>

		<div
			v-if="!sortedPoints || loading"
			v-for="n in 5"
			class="point"
		>
			<div class="placeholder" v-for="n in 3" />

		</div>
	</div>
</template>
<script type="text/javascript">

import PointSchedule from './PointSchedule'

export default {
	props: {
		selectedPointId: {
			type: String,
			default: null
		},
		loading: {
			type: Boolean,
			default: false
		},
		points: {
			type: Array,
			default () {
				return null
			}
		},
		currentZip: {
			type: String,
			default: null
		}
	},

	components: {
		PointSchedule
	},

	computed: {
		sortedPoints () {
			if (!this.points) return
			return this.points.sort((a, b) => Math.abs(this.currentZip - a.address.zip_code) - Math.abs(this.currentZip - b.address.zip_code))
		}
	},

	mounted () {

	}
}
</script>

<style scoped>

.point {
	border-bottom: 1px solid #ededed;
	padding: 10px;
	cursor: pointer;
	margin: 0 0px;
}

.point.active {
	border: 1.5px solid  var(--quomi-primary);
}

.placeholder {
	background: #ededed;
	height: 15px;
	margin: 3px 0;
}

.placeholder:nth-child(3n-2) {
	width: 80%;
}

.placeholder:nth-child(3n-1) {
	width: 40%;
}

.placeholder:nth-child(3n) {
	width: 70%;
}

</style>